import React from 'react';
import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { p14 } from '../../styles/typography';
import SearchSvg from '../svg/search';

const Host = styled.div`
  position: relative;
`;

const Input = styled.input`
  ${p14};
  width: 100%;
  display: flex;
  padding: 9px ${gutter(2)};
  border: 1px solid ${color('gray50')};
  border-radius: ${(props) => props.theme.border.radius}px;
  padding-right: ${gutter(5)};
  height: 42px;
`;

const Svg = styled.span`
  position: absolute;
  right: 10px;
  top: 11px;
`;

interface SearchInputProps extends React.ComponentPropsWithoutRef<'input'> {
  placeholder: string;
}

export const SearchInput = ({ placeholder, ...rest }: SearchInputProps) => {
  return (
    <Host>
      <Input placeholder={placeholder} {...rest} />
      <Svg>
        <SearchSvg />
      </Svg>
    </Host>
  );
};
